import { render, staticRenderFns } from "./PRJ405M03.vue?vue&type=template&id=81c67e8a&"
import script from "./PRJ405M03.vue?vue&type=script&lang=js&"
export * from "./PRJ405M03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports